import { action, observable } from 'mobx';

import { type CoinType } from '../cointype/CoinTypeStore';

export class Loadable {
  @observable
  public loading: boolean = false;

  @observable
  public error: string = '';

  public loadingByCoinType: Record<CoinType, boolean> = {
    GC: false,
    SC: false,
  };

  @action
  protected setLoading(loading: boolean) {
    this.loading = loading;
  }

  @action
  protected setLoadingByCoinType(coinType: CoinType, loading: boolean) {
    this.loadingByCoinType[coinType] = loading;
  }

  @action
  protected setError(error: string) {
    this.error = error;
  }
}
